import { useState } from 'react'
import s from './EditProposalTemplate.scss'
import { Container } from 'reactstrap'
import { WordEditor, HtmlEditor } from 'components/ideal-core-ui'
import cn from 'classnames'
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa'
import Select from 'react-select'

const pageTypes = [
  { value: 'a4', label: 'A4' },
  { value: 'letter', label: 'Letter' }
]

const EditProposalTemplate = ({
  proposalContent,
  editedProposalTemplate,
  drawerCallback,
  saveActions,
  title,
  hasTitle,
  templateType,
  pageType,
  setPageType,
  categories,
  pages,
  height
}) => {
  const [infoOpened, setInfoOpened] = useState(true)
  return (
    <>
      <Container className={s.container}>
        <div
          className={cn(s.infoSidebar, {
            [s.opened]: infoOpened
          })}
        >
          <div
            className={s.toggler}
            onClick={() => {
              setInfoOpened(state => !state)
              drawerCallback && drawerCallback(!infoOpened)
            }}
          >
            {infoOpened ? (
              <FaAngleLeft className={s.arrow} />
            ) : (
              <FaAngleRight className={s.arrow} />
            )}
          </div>
          <div className={s.infoWrapper}>
            {templateType !== 'HTML' && (
              <>
                <h6 className={s.title}>Auto-save is ON</h6>
                <p className={s.description}>A draft is auto-saved every 2 minutes.</p>
                <h6 className={s.title}>Spacing</h6>
                <p className={s.description}>
                  If there is too much space between the lines, use SHIFT+ENTER for new line and
                  SHIFT+ENTER twice for new paragraph.
                </p>
              </>
            )}
            <h6 className={s.title}>Merge Fields</h6>
            <p className={s.description}>
              You can include merge fields in your proposal for personalization.
            </p>
            <p className={s.description}>
              Simply copy the merge field code into the proposal and it will update when you
              generate the proposal on the next step.
            </p>
            <p className={s.description}>
              Copy code including brackets &#123;&#123;code&#125;&#125;.
            </p>
            <h6 className={s.title}>Today&apos;s date:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;current-date&#125;&#125;</p>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;current-time&#125;&#125;</p>
            <hr />
            <h6 className={s.title}>Organization Name:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-name&#125;&#125;
            </p>
            <h6 className={s.title}>Organization Phone:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-phone&#125;&#125;
            </p>
            <h6 className={s.title}>Organization Address:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-address&#125;&#125;
            </p>
            <h6 className={s.title}>Organization Street:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-street&#125;&#125;
            </p>
            <h6 className={s.title}>Organization City:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-city&#125;&#125;
            </p>
            <h6 className={s.title}>Organization State:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-state&#125;&#125;
            </p>
            <h6 className={s.title}>Organization Zip:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;organization-zip&#125;&#125;
            </p>
            <hr />
            <h6 className={s.title}>Contact Salutation:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;contact-salutation&#125;&#125;
            </p>
            <h6 className={s.title}>Contact First Name:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-proposal-receiver-firstname&#125;&#125;
            </p>
            <h6 className={s.title}>Contact Full Name:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-proposal-receiver-fullname&#125;&#125;
            </p>
            <h6 className={s.title}>Contact Email:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-proposal-receiver-email&#125;&#125;
            </p>
            <h6 className={s.title}>Contact Phone:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;contact-phone&#125;&#125;
            </p>
            <hr />
            <h6 className={s.title}>Client Company Name:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;company-name&#125;&#125;</p>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-legal-name&#125;&#125;
            </p>
            <h6 className={s.title}>Client Company Address:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-address&#125;&#125;
            </p>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-street-address&#125;&#125;
            </p>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-city&#125;&#125;, &#123;&#123;company-state&#125;&#125;
            </p>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;company-zip&#125;&#125;</p>
            <h6 className={s.title}>Client Company Phone:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;company-phone&#125;&#125;
            </p>
            <hr />
            <h6 className={s.title}>Project Name:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;deal-name&#125;&#125;</p>
            <h6 className={s.title}>Project Address:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;deal-address&#125;&#125;</p>
            <h6 className={s.title}>Project/Quote Number:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;quote-number&#125;&#125;</p>
            <hr />
            <h6 className={s.title}>Proposal Full Name:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;proposal-full-name&#125;&#125;
            </p>
            <hr />
            <h6 className={s.title}>Opportunity Manager:</h6>
            <p className={cn(s.description, s.placeholder)}>&#123;&#123;deal-manager&#125;&#125;</p>
            <h6 className={s.title}>Opportunity Manager Cell:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;deal-manager-cell&#125;&#125;
            </p>
            <h6 className={s.title}>Opportunity Manager Email:</h6>
            <p className={cn(s.description, s.placeholder)}>
              &#123;&#123;deal-manager-email&#125;&#125;
            </p>
          </div>
        </div>
        <div
          className={cn(s.wordEditorWrapper, {
            [s.opened]: infoOpened
          })}
        >
          {templateType === 'WORD' ? (
            <WordEditor
              title={title}
              hasTitle={hasTitle}
              template={editedProposalTemplate || proposalContent}
              saveActions={saveActions}
              height={height}
            />
          ) : (
            <>
              <Select
                placeholder="Page Type"
                value={pageType.value ? pageType : pageTypes.find(t => t.value === pageType)}
                onChange={value => setPageType(value.value)}
                options={pageTypes}
                className={s.layoutSelect}
              />
              <HtmlEditor
                pages={pages}
                pageType={pageType}
                categories={categories}
                actions={saveActions}
              />
            </>
          )}
        </div>
      </Container>
    </>
  )
}

export default EditProposalTemplate
